import { RecordingPageTypes } from '../../api/user/RecordingApi.types';
import { PageType } from '../../api/models/Shared.types';

/**
 * @param {string} recPageType
 * @returns {PageType}
 * @private
 */
export function mapRecordingPageType(recPageType: string): PageType | undefined {
  switch (recPageType) {
    case RecordingPageTypes.recorded:
      return PageType.RecordingRecorded;
    case RecordingPageTypes.planned:
      return PageType.RecordingPlanned;
    case RecordingPageTypes.conflict:
      return PageType.RecordingConflict;
    case RecordingPageTypes.expires:
      return PageType.RecordingExpired;
  }
  return undefined;
}

/**
 * @param {string} pageType
 * @returns {RecordingPageTypes}
 */
export function mapToRecordingPageType(pageType: string): RecordingPageTypes | undefined {
  switch (pageType) {
    case PageType.RecordingRecorded:
      return RecordingPageTypes.recorded;
    case PageType.RecordingPlanned:
      return RecordingPageTypes.planned;
    case PageType.RecordingExpired:
      return RecordingPageTypes.expires;
    case PageType.RecordingConflict:
      return RecordingPageTypes.conflict;
  }
  return undefined;
}
